import React, { Suspense } from 'react'

import { Provider as ReduxProvider } from 'react-redux'

import { IxAuthProvider } from './auth-context'
import { IxThemeProvider } from './theme-context'
import { IxGlobalFilterProvider } from './global-filter-context'

import { FullPageSpinner } from 'pages/full-page-spinner'

import { rootStore } from 'store'

export const IxAppProvider = ({ children }: any) => {
    return (
        <ReduxProvider store={rootStore}>
            <IxAuthProvider>
                <IxThemeProvider>
                    <IxGlobalFilterProvider>
                        <Suspense fallback={<FullPageSpinner />}>
                            {children}
                        </Suspense>
                    </IxGlobalFilterProvider>
                </IxThemeProvider>
            </IxAuthProvider>
        </ReduxProvider>
    )
}
